module.exports = __webpack_public_path__ + "071fe2aa5717030a8417e65f92044d58.pdf";